import React from 'react';
import PropTypes from 'prop-types';
import './AvatarInitials.css';

function AvatarInitials({ name, isRound, disable = false, full = false, onClick, className, style, styleSpan }) {
  const words = name.split(' ');
  const initials = !full ? words.reduce( (base, value) => {
    if (base.length < 2) {
      base += (value[0]) ? value[0].toUpperCase() : ``;
    }
    return base.replace(`(`, '');
  }, ``) : name;

  return (
    <div onClick={onClick} className={`${className}`} style={{ ...style }} >
      <span className={`avatar-initials ${isRound && `round`} ${disable && `disable`}`} style={styleSpan}>{initials}</span>
    </div>
  )
}

AvatarInitials.propTypes = {
  name: PropTypes.string.isRequired,
  isRound: PropTypes.bool.isRequired,
  disable: PropTypes.bool,
  full: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
}

export default AvatarInitials;
